import { useState, useEffect, useCallback } from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Row, Col } from 'react-bootstrap';
// import dayjs from "utils/dayjs";

import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import Chip from '@mui/material/Chip';

import { useEnumApi } from 'contexts/EnumApiContext';
import { ROLE } from 'data/data';
import { getEquipmentsById } from 'components/axios/equipmentAxios';
import { getAttentionObservationsById, getEquipmentAlertsById, patchAttentionObservationsRelease } from 'components/axios/equipmentAlertsAxios';
import { deleteMaintenanceTasks, getMaintenanceTasksById } from 'components/axios/maintenanceAxios';
import MainCard from 'components/MainCard';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import EquipmentAlertListCard from './mainCard/EquipmentAlertListCard';
import EquipmentStatusCard from './mainCard/EquipmentStatusCard';
import EquipmentAlertAndInspectionTable from 'components/table/EquipmentAlertAndInspectionTable';
import FileDownloadIcon from 'components/FileDownloadIcon';
import ConstantInspectionModal from 'components/modal/ConstantInspectionModal';
// import EquipmentSuspendRequestLayer from 'components/layer/EquipmentSuspendRequestLayer';
import AttentionObservationModal from 'components/modal/AttentionObservationModal';
import MaintenanceTaskModal from 'components/modal/MaintenanceTaskModal';
import ComprehensiveReportLayer from 'components/layer/ComprehensiveReportLayer';
import useConfig from 'hooks/useConfig';
import { fromServerFormat, nowFormat } from 'components/date_picker/dateUtils';
import { writeAuditLog } from 'components/axios/auditLogger';
import PermissionButton from 'components/PermissionButton';
import { PERMISSIONS } from 'config/permissions';
import AttentionObservationInfoCard from './mainCard/AttentionObservationInfoCard';
import MaintenanceTaskInfoCard from './mainCard/MaintenanceTaskInfoCard';

const EquipmentAlertViewMonitoringPage = ({alertId:id}) => {
    const { getEnumValueByEnumNameAndCode, loginInfo } = useEnumApi();
    const { t } = useTranslation();
    const { mode } = useConfig();

    const todayNum = nowFormat("YYYYMMDD");

    const [isLoading, setIsLoading] = useState(false);

    const requestRefresh = useCallback(() => {
      setIsLoading(false)
    }, []);
    
    // modal 관련
    const { openModal } = useModals();
    const handleAlertClick = (alertMessage) => {
      openModal(modals.alertModal, {
          onClose : () => {
              console.log(1111);
          },
          message: alertMessage,
      });
    };

    const [equipmentAlert, setEquipmentAlert] = useState(null);
    const [info, setInfo] = useState(null);
    const [previewImage, setPreviewImage] = useState(process.env.PUBLIC_URL+"/img/sample.png");
    const [companyName, setCompanyName] = useState();
    const [attentionObservation, setAttentionObservation] = useState();
    const [maintenanceTask, setMaintenanceTask] = useState();
    
    useEffect(() => {
        equipmentAlertInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[id, isLoading]);

    const equipmentAlertInfo = async () => {
      if (!id) return;

      try {
        // setIsLoading(true);

        // 1. 병렬 호출
        const [alertData] = await Promise.all([
          getEquipmentAlertsById(id),
          // getAttentionObservationsByQuery({ "equipmentAlert.id": id })
        ]);

        // alert
        setEquipmentAlert(alertData);

        if (!alertData) return;

        // company
        if (loginInfo?.company?.type === 'MAN' && alertData.equipment?.maintenanceCompany?.info?.name) {
          setCompanyName(alertData.equipment?.maintenanceCompany?.info?.name)
        } else {
          setCompanyName(alertData.equipment?.managementCompany?.info?.name)
        }

        // 2. equipment + station 병렬
        const [
          equipment
          // , stationData
        ] = await Promise.all([
          getEquipmentsById(alertData.equipment.id),
          // getStationsByQuery({ id: alertData.equipment.station.id })
        ]);

        setInfo(equipment);

        // if (stationData && stationData._embedded) {
        //   setStation(stationData._embedded.stations[0]);
        // }

        // 3. maintenanceTask (조건부)
        if (alertData.mntTask?.id) {
          const task = await getMaintenanceTasksById(alertData.mntTask.id);
          setMaintenanceTask(task || null);
        } else {
          setMaintenanceTask(null);
        }

        // observation
        if (alertData.atentObserv?.id) {
          const atentObserv = await getAttentionObservationsById(alertData.atentObserv.id);
          setAttentionObservation(atentObserv || null);
        } else {
          setAttentionObservation(null);
        }
        
        setIsLoading(true);
      } catch (err) {
        console.error(err);
      } finally {
        // setIsLoading(false);
      }
    };

    useEffect(()=>{
      // if (info && info.imgFile) {
      //     setImageFromFile(info.imgFile);
      // } else {
      //     setPreviewImage(mode === 'light' ? process.env.PUBLIC_URL+"/img/sample1.png" : process.env.PUBLIC_URL+"/img/sample.png")
      // }
      if (info) {
        if (info && info.imgFiles && info.imgFiles.length > 0) {
          setImageFromFile(info.imgFiles[0]);
        } else {
          setPreviewImage(mode === 'light' ? process.env.PUBLIC_URL+"/img/sample1.png" : process.env.PUBLIC_URL+"/img/sample.png")
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[info]);

    const setImageFromFile = ( file ) => {
        setPreviewImage(window.RUNTIME_CONFIG.REACT_APP_API_URL+"/api/download/"+file?.id);
    };

    const risUserModal = (id) => {
      openModal(modals.promptModal, {
          onSubmit : (value) => {
              let body = {
                  id,
                  risUser : value
              }
              patchAttentionObservationsRelease(id, body)
              .then(async(res) => {
                  console.log(res)
                  await writeAuditLog({
                      actionType: "UPDATE",
                      targetType: "ALERT",
                      targetId: id,
                      targetName: info?.equipmentNo,

                      apiUrl : `/api/attentionObservations/${id}:release`,
                      requestMethod : 'PATCH',
                      // summary: t('message.common.log.memo.alert.attentionObservation.update.release'),
                      summary: 'message.common.log.memo.alert.attentionObservation.update.release',
                      payload : body
                  });
                  
                  requestRefresh();
              })
          },
          onClose : () => {
              console.log('close');
          },
          message: t('message.common.alert.release.handler.input'),
          originValue : ''
      });
    }

    const handleAlertDelete = () => {
      console.log('경보삭제')
    }

    const handleMaintenanceDelete = (param) => {
      console.log('유지보수삭제')
      console.log(param)
      openModal(modals.confirmModal, {
        onSubmit : (value) => {
          deleteMaintenanceTasks(param)
          .then(async(res) => {
              console.log(res)
              await writeAuditLog({
                  actionType: "DELETE",
                  targetType: "ALERT",
                  targetId: param,
                  // targetName: equipmentAlert?.id,
                  targetName: info?.equipmentNo,

                  apiUrl : `/api/maintenanceTasks/${param}`,
                  requestMethod : 'DELETE',
                  // summary: t('message.common.log.memo.alert.maintenance.delete'),
                  summary: 'message.common.log.memo.alert.maintenance.delete',
                  payload : null
              });
              requestRefresh();
              // document.location.href = '..'+window.location.search;
          }).catch((err)=>{
            console.log(err);
            handleAlertClick(err.response?.data?.message || err.message);
          });
        },
        onClose : () => {
          console.log('close');
        },
        message: t('message.common.alert.maintenance.delete.question'),
      });
    }

    const handleObservationDelete = () => {
      console.log('주의관찰삭제')
    }

    if (equipmentAlert) {
        let level3ClassName = "step_active_n";
        if (equipmentAlert.status === null || equipmentAlert.status === undefined || equipmentAlert.status === 'M') {
          level3ClassName = "step_active";
          if (equipmentAlert.fllwActionType === 'O2_OBSERVE') {
            if (attentionObservation) {
              if (attentionObservation.endYmd === undefined || (attentionObservation.endYmd && attentionObservation.endYmd.replaceAll('-','') < todayNum)) {
                level3ClassName = "step_active_n";
              } else {
                level3ClassName = "step_active";
              }
            }
          } else if (equipmentAlert.fllwActionType === 'O3_MNT') {
            if (maintenanceTask) {
              if (maintenanceTask.status === 'O1_R') {
                level3ClassName = "step_active_n";
              } else if (maintenanceTask.status === 'O2_P') {
                level3ClassName = "step_active_i";
              } else if (maintenanceTask.status === 'O3_C') {
                level3ClassName = "step_active";
              }
            } else {
              level3ClassName = "step_active_n";
            }
          }
        }

        if (isLoading) {
          let titleLinkUrl = "../";
          return (
          <div className="sub_container">
            <div className="moni_tit_box">
            <h5 style={{color:"#fff", borderRadius:"0"}}>
              {equipmentAlert.equipment?.name}({equipmentAlert.equipment?.equipmentNo}){companyName ? ' - '+companyName:''}
              </h5>
              &nbsp;<ComprehensiveReportLayer info={info} previewImage={previewImage} />
            </div>

            <Row>
              <Col sm={7} className="sub_left">
                <div className='alert_phrase'>
                  <MainCard className="center_table" content={false}>
                    
                    <div className="stpes" style={{display:"flex", alignItems:"center", flexWrap:"wrap"}}>
                      <Chip label={t('message.common.chip.alert.site.inspection.detail')} color="error" />
                      <div>
                        <ul style={{marginBottom:"0"}}>
                          <li className={`step_active`}><span style={{padding:"4px 12px"}}>1</span><span>{t('message.common.subtitle.alert.generation')}</span></li>
                          <li>&gt;&gt;&nbsp;</li>
                          <li className={`step_active${(equipmentAlert.status === 'F' || (equipmentAlert.status === null || equipmentAlert.status === undefined || equipmentAlert.status === 'M')) ? "" : "_n"}`}><span>2</span><span>{t('message.common.chip.constantInspection')}</span></li>
                          <li>&gt;&gt;&nbsp;</li>
                          <li className={level3ClassName}>
                            <span>3</span>
                            {(equipmentAlert.status === null || equipmentAlert.status === undefined || equipmentAlert.status === 'M') ?
                            <span>{getEnumValueByEnumNameAndCode("FollowActionType", equipmentAlert.fllwActionType)?.[0]?.title}</span> : <span>{t('message.common.subtitle.fllwActionType')}</span>
                            }
                          </li>
                        </ul>
                      </div>
                    </div>

                    <EquipmentAlertAndInspectionTable equipmentAlert={equipmentAlert} />
                  </MainCard>
                </div>

                {/* {equipmentAlert && equipmentAlert.fllwActionType === 'O3_MNT' 
                    && maintenanceTask.status === 'O1_R' &&
                <div className='alert_phrase'>
                  <MainCard content={false} style={{marginBottom:"10px"}}>
                      <TableContainer>
                      <Table aria-label="simple table" className="green_table maint_table">
                          <TableBody>
                            <TableRow className='td_green'>
                              <TableCell className="th" style={{width:"150px"}}>{t('message.common.title.maintenance')}</TableCell>
                              <TableCell><div style={{color:'#FF8A34'}}>{t('message.common.text.wait')}</div></TableCell>
                              <TableCell>
                                  <div style={{textAlign:"right"}}>
                                  <MaintenanceTaskModal id={maintenanceTask.id} onRefresh={requestRefresh} />
                                  </div>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                      </Table>
                      </TableContainer>
                  </MainCard>
                </div>
                } */}
    
                {/* 버튼 */}
                <div className="btn_right" style={{marginBottom:"15px"}}>
                  {equipmentAlert.fllwActionType ?
                    <>
                      {/* {equipmentAlert.fllwActionType === 'O2_OBSERVE' && attentionObservation === null && <AttentionObservationModal alertId={equipmentAlert.id} onRefresh={requestRefresh} />} */}
                      {equipmentAlert.fllwActionType === 'O2_OBSERVE' && attentionObservation && <AttentionObservationModal alertId={equipmentAlert.id} onRefresh={requestRefresh} type="modify" />}
                      {equipmentAlert.fllwActionType === 'O3_MNT' && maintenanceTask && <MaintenanceTaskModal id={maintenanceTask?.id} onRefresh={requestRefresh} type="modify" />}
                    </>
                  : ""}
                  <ConstantInspectionModal alertId={equipmentAlert.id} onRefresh={requestRefresh} /*type={"icon"}*/ />
                  {/* {equipmentAlert.alertCategory === 'MNT_IR' && equipmentAlert.status === 'D' &&
                  <PermissionButton
                      permission={PERMISSIONS.ALERT_DELETE}
                      variant="contained" style={{padding:"2px 5px", marginLeft:"10px"}} color="error" onClick={handleAlertDelete}
                  >
                      경보삭제
                  </PermissionButton>
                  } */}
                </div>
                
                {/* 주의관찰 */}
                {equipmentAlert.fllwActionType && equipmentAlert.fllwActionType === 'O2_OBSERVE' && attentionObservation && (
                  <AttentionObservationInfoCard attentionObservation={attentionObservation} equipmentAlert={equipmentAlert} onRefresh={requestRefresh}/>
                )}

                {/* 유지보수 */}
                {equipmentAlert.fllwActionType && equipmentAlert.fllwActionType === 'O3_MNT' && maintenanceTask &&
                  <MaintenanceTaskInfoCard maintenanceTask={maintenanceTask} onRefresh={requestRefresh} />
                }

                {/* 점검내역추적관리 */}
                <EquipmentAlertListCard equipmentId={info && info.id} equipmentNo={info && info.equipmentNo} />

                <div style={{ marginTop: "10px" }}>
                  <Link to={'..' + window.location.search}>
                    <Button
                      className="pop_style_btn"
                      type="button"
                      style={{
                        height: "35px",
                        minHeight: "35px"
                      }}
                    >
                      <span>{t('message.common.btn.list')}</span>

                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                        style={{
                          display: "block",
                          flexShrink: 0
                        }}
                      >
                        <path d="M8 6h13M8 12h13M8 18h13" />
                        <path d="M3 6h.01M3 12h.01M3 18h.01" />
                      </svg>
                    </Button>
                  </Link>
                </div>
              </Col>
    
              <Col sm={5} className="sub_right">
                {/* 설비 현황 및 상태 */}
                <EquipmentStatusCard info={info} onRefresh={requestRefresh} />    
              </Col>
            </Row>
          </div>
        )
      }
    }
}

export default EquipmentAlertViewMonitoringPage;